import pharmacyNoBearer from 'services/pharmacyNoBearer';
import { useDispatch } from 'react-redux';
import { SET_ERROR_MESSAGE } from 'helpers/types';

export default () => {
  const dispatch = useDispatch();
  const postLog = async (monitoringEvent) => {
    const postValues = {
      log_event: monitoringEvent,
    };
    try {
      const response = await pharmacyNoBearer.post(`/log-event`, postValues);
      return response;
    } catch (e) {
      if (e.response && e.response.data.readable_error_message) {
        dispatch({
          type: SET_ERROR_MESSAGE,
          payload: {
            msg: e.response.data.readable_error_message,
            newMessage: true,
            link: '',
            ctaText: '',
          },
        });
      }
    }
  };

  return [postLog];
};
